import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { getAnonymousTokenCookie } from '@avanta/shared/utils/storage';
import { type AxiosResponse } from 'axios';
import {
  type CreateEmployeesPayload,
  type CreateEmployeesResult,
  type CreateEmployeePayload,
  type Employee,
} from 'types/employees';

const EMPLOYEES_URL = `${BASE_URL}employees`;

type EmployeeServiceTypes = {
  createEmployee: (employee: CreateEmployeePayload) => Promise<AxiosResponse<Employee>>;
  createEmployees: (
    payload: CreateEmployeesPayload
  ) => Promise<AxiosResponse<CreateEmployeesResult[]>>;
};

export const EmployeeService: EmployeeServiceTypes = {
  createEmployee: async employee => {
    const body = { ...employee, type: 'EmployeeToRegisterDTO' };
    const anonymousToken = getAnonymousTokenCookie();
    return service.post(EMPLOYEES_URL, body, {
      headers: {
        Authorization: `Bearer ${anonymousToken}`,
        'Content-Type': 'application/json',
      },
    });
  },
  createEmployees: async payload => service.post(`${EMPLOYEES_URL}/list`, payload),
};
